/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { useEffect, useState } from 'react';

export function useTimePickerPopover(openInitially: boolean) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(openInitially);
  return { isPopoverOpen, setIsPopoverOpen };
}

export function useKeyboardNavigation(
  listRef: React.RefObject<HTMLUListElement | null | undefined>,
  maxIndex: number,
) {
  const [focusedIndex, setFocusedIndex] = useState(0);

  const handleArrowNavigation = (key: string) => {
    if (key === 'ArrowDown') {
      setFocusedIndex((prev) => (prev + 1) % maxIndex);
    } else if (key === 'ArrowUp') {
      setFocusedIndex((prev) => (prev - 1 + maxIndex) % maxIndex);
    }
  };

  useEffect(() => {
    listRef.current?.children[focusedIndex]?.scrollIntoView({
      block: 'center',
      inline: 'nearest',
    });
  }, [focusedIndex, listRef]);

  return { focusedIndex, handleArrowNavigation, setFocusedIndex };
}
